import { connect } from 'react-redux';
import { removeAlertUserAvatar, saveAlertUserImage, saveAlertUserName } from './routines';
import AlertUser from '../../Components/Dashboard/AlertUser';

function mapStateToProps(state) {
    return { alertUser: state.alertUser };
}
const mapDispatchToProps = {
    saveAlertUserImage,
    saveAlertUserName,
    removeAlertUserAvatar,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AlertUser);
